export var cifAm = ["301 151", "<g fill='none'><path fill='#D90012' d='M.5.5h300v150H.5z'/><path fill='#0033A0' d='M.5 50.5h300v50H.5z'/><path fill='#F2A800' d='M.5 100.5h300v50H.5z'/></g>"];
